<template>
  <div class="home py-5">
    <span class="d-flex flex-row page-title">{{$t("intranet.title.page.superAmbassador.update")}}</span>
    <div v-if="dataLoaded" class="form-container">
      <AveineSuperAmbassadorForm :APIbaseURL="APIbaseURL" :superAmbassador="superAmbassador" :adminMode="true"/>
    </div>
    <div v-else class="d-flex justify-center align-center mt-16">
      <v-progress-circular
        indeterminate
        :size="100"
        :width="10"
        color="secondary"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { AveineSuperAmbassadorForm } from 'aveine-super-ambassador'
import { SuperAmbassador } from 'aveine-toolbox'
import { errorHandler } from 'aveine-toolbox'
export default {
  data () {
    return {
      superAmbassador: {},
      dataLoaded: false,
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },
  name: 'Create',
  components: {
    AveineSuperAmbassadorForm
  },
  async created() {
    try {
      await SuperAmbassador.api().get(`super-ambassadors/${this.$route.params.id}?lang=${this.$i18n.locale}`, {
        params: {
          include:
          'company.company-contact,company.address.spatial-information',
        }
      });
      this.superAmbassador = await SuperAmbassador.query().whereId(this.$route.params.id).withAllRecursive().first();
      this.dataLoaded = true;
    } catch (errors) {
      this.dataLoaded = true;
      errorHandler(errors, this)
    }
  }
}
</script>
